import { render, staticRenderFns } from "./checkLogin.vue?vue&type=template&id=16622e50&"
import script from "./checkLogin.vue?vue&type=script&lang=js&"
export * from "./checkLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports